module.exports = __webpack_public_path__ + "img/btn-count-down-on.0df7bbbc.png";